import React, { useState, useEffect, useMemo, useCallback } from 'react'
import Navbar from "../../component/HeaderData";
import Footer from "../../component/FooterData";
import BackButton from '../../component/Common/BackBtn'
import { useMsal } from '@azure/msal-react'
import { useHistory } from 'react-router-dom'
import PageSubTitle from '../../component/Common/PageSubTitle'
import ReactDataGrid from '@inovua/reactdatagrid-enterprise'
import { useReportInventoryService } from '../../services/ReportInventoryServices';
import { set } from 'lodash';
import _, { concat } from 'lodash'
import Button from '../../component/Common/Button'
import Dropdown from "../../component/Common/Dropdown";
import InputText from '../../component/Common/InputText'
import Modal from 'react-modal';
import * as XLSX from 'xlsx'
// import './user-management.css'
import moment from 'moment'
import { useLooksUpData } from '../../utils/getLookupTableData';
import { useAccessControl } from '../../../src/utils/AccessControlContext';
import Cookies from 'js-cookie';
import { formatDateForDisplay, formatDateOnlyForDisplay, setDateInCST } from '../../utils/dateUtils';
import { savedFilters } from '../../App'
import { toast } from 'react-toastify';
import { Error_Messages } from '../../utils/statusConstantValues';
import confirmYesNo from '../../component/Common/ConfirmYesNo';

const UserManagement = () => {
    const { instance, accounts } = useMsal()
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(false)
    const gridStyle = { minHeight: 550, width: '100%' };
    const ReportInventoryService = useReportInventoryService();
    let [mcUsersList, setMcUsersList] = useState<UserList[]>([]);
    const [selectedOption1, setSelectedOption1] = useState(
        (savedFilters?.UserManagemnetPage as any)?.selectedOption1 ||
        (null as any),
    );
    const [selectedOption2, setSelectedOption2] = useState(
        (savedFilters?.UserManagemnetPage as any)?.selectedOption1 ||
        (null as any),
    );
    const [filter1Text, setFilter1Text] = useState<string | null>(null);
    const [filter2Text, setFilter2Text] = useState<string | null>(null);
    const [isDisabled, setIsDisabled] = useState<boolean>(true);
    const [isExportModalOpen, setIsExportModalOpen] = useState(false);
    const [gridRef, setGridRef] = useState(null as any)
    let [mcOrgUnitsList, setMcOrgUnitsGroupsList] = useState<any>([]);
    const [accountStatusLKPCDList, setAccountStatusLKPCDList] = useState<any>([])
    const [userChangeRequestStatusList, setUserChangeRequestStatusList] = useState<any>([])
    const { getMasterTableLookupValueData, getOrganizationUnitsTableLookupData, getUserGroupTableLookupData } = useLooksUpData();
    const { checkAccess } = useAccessControl();
    const [filteredReportResponseList, setFilteredReportResponseList] = useState<UserList[]>([]);
    let [accountTypeList, setAccountTypeList] = useState<any>([]);
    let [changeRequestTypeList, setChangeRequestTypeList] = useState<any>([]);
    let [reviewersGroupsList, setReviewersGroupsList] = useState<any>([]);
    let [mcUserGroupsList, setMcUserGroupsList] = useState<any>([]);
    const [filterSearchOption, setFilterSearchOption] = useState(false);
    const loggedInUserDetails = JSON.parse(sessionStorage.getItem('loginUserDetails') || '{}');
    const isNonStateUser = loggedInUserDetails.organizationUnitCode !== "NEDHHS";
    let envPrefix = process.env.REACT_APP_ENV_PREFIX || '';
    const [allowedDomains, setAllowedDomains] = useState<string[]>([])

    interface UserList {
        userSid: string;
        organization: string;
        userLastName: string;
        userFirstName: string;
        userId: string;
        startDate: string;
        endDate: string;
        accountStatusLkpcd: string;
        updatedDate: string;
        chngRqst: string;
        chngRqstCode?: string;
        funlUserFlag: string;
        _rowId?: string;
        mucrAccountTypeLkpcd?: string;
        mucrAfStatusLkpcd?: string;
        mucrCreatedBy?: string;
        mucrUpdatedDate?: string;
        chngRqstSid?: string;
        mcTableFunlUserFlag?: string;
        updatedBy?: string;
    }

    const headers = [
        'Organization',
        'Last Name',
        'First Name',
        'User/Email ID',
        'Effective From Data',
        'Effective To Date',
        'Operational User',
        'Account Status',
        'Change Request Type',
        'Last Updated Date'
    ];
    const [selectedHeaders, setSelectedHeaders] = useState<string[]>(headers);

    const fetchGetMcOrganizationUnitsTableLookupValueData = async () => {
        try {
            const response = await getOrganizationUnitsTableLookupData();
            if (response) {
                const { data } = response;

                const filterAndMapData = () => {
                    return data
                        // .filter((dt: any) => dt.organizationUnitCtgryLkpcd === 'NMR')
                        .map((code: any) => ({
                            organizationUnitCode: `${code.organizationUnitCode}`,
                            organizationUnitName: code.organizationUnitName,
                            organizationUnitCtgryLkpcd: code.organizationUnitCtgryLkpcd,
                            oprtnlFlag: code.oprtnlFlag,
                            parentOrgUnitCode: code.parentOrgUnitCode
                        }));
                };

                setMcOrgUnitsGroupsList(filterAndMapData);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const fetchGetMasterTableLookupValueData = async () => {
        try {
            const response = await getMasterTableLookupValueData();
            if (response) {
                const { data } = response;

                const filterAndMapData = (group: string, table: string, column: string) => {
                    return data
                        .filter((dt: any) => dt.lkpcd_group === group && dt.table_name === table && dt.column_name === column)
                        .map((code: any) => ({
                            lkpdmn_lkpcd: `${code.lkpdmn_lkpcd}`,
                            lkdmn_lkpcd_desc: code.lkdmn_lkpcd_desc,
                            lkpcd_group: code.lkpcd_group,
                        }));
                };

                const mcAccountStatusLKPCD = filterAndMapData('NG', 'MC_USER', 'ACCOUNT_STATUS_LKPCD');
                const mcAfStatusLKPCD = filterAndMapData('NG', 'MC_USER_CHANGE_REQUEST', 'AF_STATUS_LKPCD');
                const mcAccountTypeLKPCD = filterAndMapData('NG', 'MC_USER', 'ACCOUNT_TYPE_LKPCD');
                const mcChangeRequestTypeLKPCD = filterAndMapData('NG', 'MC_USER_CHANGE_REQUEST', 'CHNG_RQST_TYPE_LKPCD');

                setAccountStatusLKPCDList(mcAccountStatusLKPCD);
                setUserChangeRequestStatusList(mcAfStatusLKPCD);
                setAccountTypeList(mcAccountTypeLKPCD);
                setChangeRequestTypeList(mcChangeRequestTypeLKPCD);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const fetchAllMcUsersData = async () => {
        try {
            const response = await ReportInventoryService.getAllUsers();
            if (response) {
                let usersList = response.data;

                // if (sessionStorage.getItem('selectedProfile') !== `DHHS_AR_NEMCIS_STT${envPrefix}-SUP-ADMIN` || sessionStorage.getItem('selectedProfile') !== `DHHS_AR_NEMCIS_STT${envPrefix}-APP-ADMIN`) {
                //     usersList = usersList.filter((item: any) => (item.userId || '').toLowerCase() === (loggedInUserDetails.userEmail || '').toLowerCase());
                //     setFilterSearchOption(true);
                // }


                const selectedProfile = (sessionStorage.getItem('selectedProfile') || "").toUpperCase();

                const isAdmin = ["SUP-ADMIN", "APP-ADMIN"].some(role => selectedProfile.includes(role));

                if (!isAdmin) {
                    usersList = usersList
                        .filter((item: any) =>
                            (item.userId || "").toLowerCase() ===
                            (loggedInUserDetails.userEmail || "").toLowerCase()
                        )
                        // remove records related to change request
                        .filter((item: any) => !item.chngRqst || item.chngRqst !== 'A')
                }

                // Sort the usersList by orgUnitCd, userLastName, then userFirstName
                usersList.sort((a: any, b: any) => {
                    if (a.organization !== b.organization) {
                        return (a.organization || '').localeCompare(b.organization || '')
                    }
                    if (a.userLastName !== b.userLastName) {
                        return (a.userLastName || '').localeCompare(b.userLastName || '');
                    }
                    return (a.userFirstName || '').localeCompare(b.userFirstName || '');
                });

                const usersWithRowId = usersList.map((item: any, idx: number) => ({
                    ...item,
                    _rowId:
                        item.userDetailsSid ||
                        item.userSid ||
                        item.userId ||
                        `${item.updatedDate || 'no-date'}-${idx}`,
                }));

                setMcUsersList(usersWithRowId);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const getMcUserGroupsByGroupCode = async (groupCode: any) => {
        try {
            const response = await ReportInventoryService.getMcUserGroupsByGroupCode(groupCode);
            if (response) {
                // setFilteredReportResponseList(response.data);
                return response.data;
            }
        } catch (e) {
            console.error(e);
        }
    };

    const getReviewAssignmentListByUnitCode = async (orgUnitCode: any) => {
        try {
            const response = await ReportInventoryService.getReviewAssignmentListByUnitCode(orgUnitCode);
            if (response) {
                // setMcUsersList(response.data);
                return response.data;
            }
        } catch (e) {
            console.error(e);
        }
    };


    const fetchGetMcUserGroupTableLookupValueData = async () => {
        try {
            const response = await getUserGroupTableLookupData();
            if (response) {
                const { data } = response;

                const filterAndMapData = () => {
                    return data
                        // .filter((dt: any) => dt.userGroupCode === group)
                        .map((code: any) => ({
                            userGroupCode: `${code.userGroupCode}`,
                            userGroupName: code.userGroupName,
                            userGroupUsage: code.userGroupUsage,
                            oprtnlFlag: code.oprtnlFlag,
                        }));
                };

                setMcUserGroupsList(filterAndMapData);
            }
        } catch (e) {
            console.log(e);
        }
    };

    const getAllReportReviewer = async () => {
        try {
            const response = await ReportInventoryService.getAllReportReviewer();
            if (response) {
                const { data } = response;
                setReviewersGroupsList(data);
            }
        } catch (e) {
            console.log(e);
        }
    }


    const handleOrgChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const orgCode = e.target.value;

        setAddUserForm((prev) => ({ ...prev, organizationUnitCode: orgCode }));

        if (orgCode) {
            const domainsResponse = await ReportInventoryService.getAllDomainsByOrgCode(orgCode);
            if (domainsResponse) {
                const { data } = domainsResponse;

                const domains = data?.map((d: any) => d.organizationUnitDomain?.toLowerCase().trim()) || [];

                setAllowedDomains(domains);
            }
        }
    };

    const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const email = e.target.value;
        setAddUserForm((prev) => ({ ...prev, userEmail: email }));

        const domain = email.split("@")[1];

        if (domain && allowedDomains.length > 0) {
            const isAllowed = allowedDomains.includes(domain);

            if (!isAllowed) {
                toast.error("Email domain not allowed");
            }
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                await fetchAllMcUsersData();
                await fetchGetMasterTableLookupValueData();
                await fetchGetMcOrganizationUnitsTableLookupValueData();
                await getAllReportReviewer();
                await fetchGetMcUserGroupTableLookupValueData();
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, []);

    useEffect(() => {
        setIsLoading(true);
        const timeoutId = setTimeout(() => {
            if ((!accounts?.[0]?.localAccountId)) {
                history.push('/sign-in');
            }
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [accounts, history]);

    useEffect(() => {
        setFilteredReportResponseList(mcUsersList);
    }, [mcUsersList]);

    const getMatchingDescription = (list: any[], data: any) => {
        if (data === null || data === undefined || data === '') {
            return '';
        }

        const normalizedData = String(data).trim().toLowerCase();
        const matchedItem = list.find((code: any) => {
            const lookupCode = String(code?.lkpdmn_lkpcd ?? '').trim().toLowerCase();
            const lookupDescription = String(code?.lkdmn_lkpcd_desc ?? '').trim().toLowerCase();

            return lookupCode === normalizedData
                || lookupDescription === normalizedData
                || lookupDescription.includes(normalizedData);
        });

        return matchedItem?.lkdmn_lkpcd_desc ?? data;
    };

    const matchingAccountStatusLkpcd = (data: any) => getMatchingDescription(accountStatusLKPCDList, data);
    const matchingChangeRequestTypeLkpcd = (data: any) => getMatchingDescription(changeRequestTypeList, data);
    const matchingUserChangeRequestStatusLkpcd = (data: any) => getMatchingDescription(userChangeRequestStatusList, data);

    const serachDropdownChoices1 = [
        {
            label: 'Account Type',
            value: 'accountTypeLkpcd',
        },
        {
            label: 'Reviewer Group',
            value: 'reviwersGroup',
        },
        {
            label: 'User Group',
            value: 'userGroups',
        }
    ]

    const serachDropdownChoices2 = [
        {
            label: 'Account Type',
            value: 'accountTypeLkpcd',
        },
        {
            label: 'Reviewer Group',
            value: 'reviwersGroup',
        },
        {
            label: 'User Group',
            value: 'userGroups',
        }
    ]

    const validateSearchBtn = () => {
        if (!(_.isEmpty(selectedOption1) || _.isEmpty(selectedOption2) || _.isEmpty(filter1Text) || _.isEmpty(filter2Text))) {
            return false;
        }
        return true;
    };

    function handleFilterChange1(event: any) {
        const selectedValue = event.target.value;
        setSelectedOption1(selectedValue);
        setIsDisabled(validateSearchBtn());
        setFilter1Text('');
    }

    function handleFilterChange2(event: any) {
        const selectedValue = event.target.value;
        setSelectedOption2(selectedValue);
        setIsDisabled(validateSearchBtn());
        setFilter2Text('');
    }

    function handleFilterText1(event: any) {
        const enteredValue = event.target.value;
        setFilter1Text(enteredValue);
        setIsDisabled(validateSearchBtn());
    }

    function handleFilterText2(event: any) {
        const enteredValue = event.target.value;
        setFilter2Text(enteredValue);
        setIsDisabled(validateSearchBtn());
    }

    function handleClear() {
        sessionStorage.removeItem('savedFilters')
        setFilter1Text('');
        setFilter2Text('');
        setSelectedOption1(null);
        setSelectedOption2(null);
        setFilteredReportResponseList(mcUsersList);
    }

    useEffect(() => {
        // Check if saved filters exist in sessionStorage
        const savedFilters = sessionStorage.getItem('savedFilters');
        if (savedFilters) {
            const parsedFilters = JSON.parse(savedFilters);
            setSelectedOption1(parsedFilters.selectedOption1);
            setSelectedOption2(parsedFilters.selectedOption2);
            setFilter1Text(parsedFilters.filter1Text);
            setFilter2Text(parsedFilters.filter2Text);
        }
    }, []);

    async function handleSearch() {
        const filtersToSave = {
            selectedOption1: selectedOption1 || '',
            selectedOption2: selectedOption2 || '',
            filter1Text: filter1Text || '',
            filter2Text: filter2Text || ''
        };

        // Only save if the filters have changed
        const currentFilters = JSON.parse(sessionStorage.getItem('savedFilters') || '{}');
        if (JSON.stringify(currentFilters) !== JSON.stringify(filtersToSave)) {
            sessionStorage.setItem('savedFilters', JSON.stringify(filtersToSave));
        }

        let filter1Value: string | number | Date | null = filter1Text;
        let filter2Value: string | number | Date | null = filter2Text;
        let programReportSids: string[] = [];
        let userSids: string[] = [];

        // Determine the filter1Value based on selectedOption1
        if (selectedOption1 === 'accountTypeLkpcd') {
            const matchingValue = accountTypeList.find((code: any) => code.lkdmn_lkpcd_desc.toLowerCase().includes((filter1Text || '').toLowerCase()));
            filter1Value = matchingValue ? matchingValue.lkpdmn_lkpcd : filter1Text;
        } else if (selectedOption1 === 'userGroups') {
            const matchingValue = mcUserGroupsList.find((code: any) => code.userGroupName.toLowerCase().includes((filter1Text || '').toLowerCase()));
            if (matchingValue) {
                const matchingReviewerGroup = await getMcUserGroupsByGroupCode(matchingValue.userGroupCode);
                if (matchingReviewerGroup) {
                    userSids = matchingReviewerGroup.map((group: any) => group.userSid);
                }
            }
        } else if (selectedOption1 === 'reviwersGroup') {
            const matchingValue = mcOrgUnitsList.find((code: any) => code.organizationUnitName.toLowerCase().includes((filter1Text || '').toLowerCase()));

            if (matchingValue) {
                const matchingReviewerGroup = await getReviewAssignmentListByUnitCode(matchingValue.organizationUnitCode);
                if (matchingReviewerGroup) {
                    userSids = matchingReviewerGroup.map((group: any) => group.userSid);
                }
            }
        }

        // Determine the filter2Value based on selectedOption2
        if (selectedOption2 === 'accountTypeLkpcd') {
            const matchingValue = accountTypeList.find((code: any) => code.lkdmn_lkpcd_desc.toLowerCase().includes((filter2Text || '').toLowerCase()));
            filter2Value = matchingValue ? matchingValue.lkpdmn_lkpcd : filter2Text;
        } else if (selectedOption2 === 'userGroups') {
            const matchingValue = mcUserGroupsList.find((code: any) => code.userGroupName.toLowerCase().includes((filter2Text || '').toLowerCase()));
            if (matchingValue) {
                const matchingReviewerGroup = await getMcUserGroupsByGroupCode(matchingValue.userGroupCode);
                if (matchingReviewerGroup) {
                    userSids = matchingReviewerGroup.map((group: any) => group.userSid);
                }
            }
        } else if (selectedOption2 === 'reviwersGroup') {
            const matchingValue = mcOrgUnitsList.find((code: any) => code.organizationUnitName.toLowerCase().includes((filter1Text || '').toLowerCase()));
            if (matchingValue) {
                const matchingReviewerGroup = await getReviewAssignmentListByUnitCode(matchingValue.organizationUnitCode);
                if (matchingReviewerGroup) {
                    userSids = matchingReviewerGroup.map((group: any) => group.userSid);
                }
            }
        }

        const filteredList = mcUsersList.filter((item: any) => {
            const matchesOption1 = selectedOption1
                ? selectedOption1 === 'reviwersGroup' || selectedOption1 === 'userGroups'
                    ? userSids.includes(item.userDetailsSid)
                    : typeof item[selectedOption1 as keyof UserList] === 'string'
                        ? (item[selectedOption1 as keyof UserList] as string).toLowerCase().includes((filter1Value as string).toLowerCase())
                        : item[selectedOption1 as keyof UserList] === filter1Value
                : true;

            const matchesOption2 = selectedOption2
                ? selectedOption2 === 'reviwersGroup' || selectedOption2 === 'userGroups'
                    ? userSids.includes(item.userDetailsSid)
                    : typeof item[selectedOption2 as keyof UserList] === 'string'
                        ? (item[selectedOption2 as keyof UserList] as string).toLowerCase().includes((filter2Value as string).toLowerCase())
                        : item[selectedOption2 as keyof UserList] === filter2Value
                : true;

            return matchesOption1 && matchesOption2;
        });


        setFilteredReportResponseList(filteredList);
    }

    const toggleModal = () => {
        setSelectedHeaders(headers);
        setIsExportModalOpen(!isExportModalOpen);
    };

    const handleHeaderChange = (header: string) => {
        setSelectedHeaders((prev) =>
            prev.includes(header) ? prev.filter((h) => h !== header) : [...prev, header]
        );
    };

    const handleSelectAllChange = () => {
        setSelectedHeaders(selectedHeaders.length === headers.length ? [] : headers);
    };

    const handleExportToExcel = () => {
        const rows = [];
        console.log('filterDataList', filterDataList);

        // 1. Add header row FIRST
        rows.push(selectedHeaders);

        // 2. Create data rows in correct order
        filterDataList.forEach(item => {
            const lookup: Record<string, string | number | undefined> = {
                'Organization': item.organization,
                'Last Name': item.userLastName,
                'First Name': item.userFirstName,
                'User/Email ID': item.userId,
                'Effective From Data': formatDateOnlyForDisplay(item.startDate, 'MM/DD/YYYY'),
                'Effective To Date': formatDateOnlyForDisplay(item.endDate, 'MM/DD/YYYY'),
                'Operational User': item.funlUserFlag,
                'Account Status': matchingAccountStatusLkpcd(item.accountStatusLkpcd),
                'Change Request Type': matchingChangeRequestTypeLkpcd(item.chngRqst),
                'Last Updated Date': item.updatedDate || '',
            };

            const row = selectedHeaders.map(h => lookup[h]);
            rows.push(row);
        });

        // 3. Build worksheet from array of arrays
        const ws = XLSX.utils.aoa_to_sheet(rows);

        // 4. Build workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'user inventory list');
        XLSX.writeFile(wb, 'user_inventory_list.xlsx');

        setIsExportModalOpen(false);
    };

    const getMatchingMcOrgUnit = (data: any) => {
        const matchedItem = mcOrgUnitsList.find((code: any) => code.organizationUnitCode === data);
        return matchedItem?.organizationUnitName || data;
    };

    const formatDateForInput = (value: any) => {
        if (value) {
            const date = moment.utc(value);
            return date.isValid() ? date.format('MM/DD/YYYY') : '';
        }
    };

    const formatDateAndTime = (value: any) => {
        if (value) {
            const date = moment.utc(value);
            return date.isValid() ? date.format('M/D/YY h:mm:ss:SSS A') : '';
        }
        return '';

    };

    const [selectedUserRecord, setSelectedUserRecord] = useState<any | null>(null);
    const hasSingleSelection = !!selectedUserRecord;

    const handleViewClick = () => {
        if (!selectedUserRecord) return;
        if (!checkAccess("user_inventory_page", "NOAC")) {
            history.push({
                pathname: "/user-management-details",
                state: { recordData: selectedUserRecord },
            });
        }
    };

    const handleCancelButton = () => {
        history.push({
            pathname: "/admin-dashboard",
        });
    };

    const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
    const [isAddSubmitting, setIsAddSubmitting] = useState(false);
    const [addUserForm, setAddUserForm] = useState({
        accountTypeLkpcd: '',
        organizationUnitCode: '',
        userEmail: '',
        oprtnlUserFlag: 'Y',
    });

    const stateAndTradingAccountTypes = useMemo(() => {
        return (accountTypeList || []).filter((x: any) => ['S', 'T'].includes(x.lkpdmn_lkpcd));
    }, [accountTypeList]);

    const organizationChoicesForSelectedAccountType = useMemo(() => {
        const category =
            addUserForm.accountTypeLkpcd === 'S'
                ? 'NSO'
                : addUserForm.accountTypeLkpcd === 'T'
                    ? 'MCP'
                    : '';
        if (!category) return [];
        return (mcOrgUnitsList || []).filter(
            (x: any) => x.organizationUnitCtgryLkpcd === category
        );
    }, [addUserForm.accountTypeLkpcd, mcOrgUnitsList]);

    const onAddAccountTypeChange = (value: string) => {
        if (value === 'E') {
            toast.error('External Users are not allowed in NEMCIS currently');
            return;
        }

        setAddUserForm((prev) => ({
            ...prev,
            accountTypeLkpcd: value,
            organizationUnitCode: '',
            oprtnlUserFlag: 'Y',
        }));

    };

    const onAddUserModalClose = () => {
        if (isAddSubmitting) return;
        setIsAddUserModalOpen(false);
        setAddUserForm({
            accountTypeLkpcd: '',
            organizationUnitCode: '',
            userEmail: '',
            oprtnlUserFlag: 'Y',
        });
    };

    const isValidEmail = (email: string) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    };

    const handleAddAccountClick = () => {
        if (selectedUserRecord) {
            toast.warning('You need not select a existing record if you are adding a new user account.');
            return;
        }
        setIsAddUserModalOpen(true);
    };


    const getRowId = (row: any) => row?.userDetailsSid || row?._rowId || row?.userSid || row?.userId;

    const handleRowCheckboxChange = (checked: boolean, rowData: any) => {
        setSelectedUserRecord(checked ? rowData : null); // single select only
    };

    const handleGridRowClick = ({ data }: any) => {
        const rowId = getRowId(data);
        if (!rowId) return;

        setSelectedUserRecord((prev: any) =>
            getRowId(prev) === rowId ? null : data
        );
    };


    const actionTypeMap: Record<string, string> = {
        Adding: "A",
        Modified: "M",
        Modifying: "M",
        Locking: "L",
        Locked: "L",
        Unlocking: "U",
        Unlocked: "U",
        A: "A",
        M: "M",
        L: "L",
        U: "U",
    };


    const UserInventoryHeaders: any[] = [
        {
            name: 'rowSelect',
            header: <div className='grid-header-custom-style'>Select</div>,
            width: 90,
            resizable: false,
            sortable: false,
            render: ({ data }: any) => (
                <input
                    type="checkbox"
                    checked={!!selectedUserRecord && getRowId(selectedUserRecord) === getRowId(data)} onClick={(e) => e.stopPropagation()}
                    onChange={(e) => handleRowCheckboxChange(e.target.checked, data)}
                    style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                />
            ),
        },
        {
            name: 'organization',
            header: (
                <div className='grid-header-custom-style'>
                    Organization
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 80,
            // maxWidth: 300,
            // render: ({ value }: { value: any }) => (
            //     <div>{getMatchingMcOrgUnit(value)}</div>
            // ),
        },
        {
            name: 'userLastName',
            header: (
                <div className='grid-header-custom-style'>
                    Last Name
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 80,
            // maxWidth: 300,
        },
        {
            name: 'userFirstName',
            header: (
                <div className='grid-header-custom-style'>
                    First Name
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 80,
            // maxWidth: 300,
        },
        {
            name: 'userId',
            header: (
                <div className='grid-header-custom-style'>
                    User/Email ID
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 80,
            // maxWidth: 300,
        },
        {
            name: 'startDate',
            header: (
                <div className='grid-header-custom-style'>
                    Effective From Date
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 80,
            // maxWidth: 300,
            render: ({ data }: { data: UserList }) => {
                return formatDateForInput(data.startDate)
            },
        },
        {
            name: 'endDate',
            header: (
                <div className='grid-header-custom-style'>
                    Effective To Date
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 80,
            // maxWidth: 300,
            render: ({ data }: { data: UserList }) => {
                return formatDateForInput(data.endDate)
            },
        },
        {
            name: 'funlUserFlag',
            header: (
                <div className='grid-header-custom-style'>
                    Operational User
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 80,
            maxWidth: 150,
            render: ({ data }: { data: UserList }) => {
                return data.funlUserFlag;
            }
        },
        {
            name: 'accountStatusLkpcd',
            header: (
                <div className='grid-header-custom-style'>
                    Account Status
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 80,
            maxWidth: 200,
            render: ({ data }: { data: UserList }) => {
                return matchingAccountStatusLkpcd(data?.accountStatusLkpcd) || "";
            },
        },
        {
            name: 'chngRqst',
            header: (
                <div className='grid-header-custom-style'>
                    Change Request Type
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 80,
            // maxWidth: 300,
            render: ({ data }: { data: UserList }) => {
                const label = data.chngRqst || "";
                const rawCode = data.chngRqstCode || data.chngRqst || "";
                const status = data.accountStatusLkpcd;

                if (
                    rawCode === "A" || rawCode === "Adding" ||
                    ((status === "A" || status === "Active") && (rawCode === "M" || rawCode === "Modifying")) ||
                    ((status === "A" || status === "Active") && (rawCode === "L" || rawCode === "Locking")) ||
                    ((status === "L" || status === "Locked") && (rawCode === "U" || rawCode === "Unlocking"))
                ) {
                    return (
                        <button
                            type="button"
                            onClick={(e) => {
                                e.stopPropagation();
                                const actionType = actionTypeMap[rawCode] || rawCode;
                                history.push({
                                    pathname: '/user-account-change-request',
                                    state: { chngRqstSid: data?.chngRqstSid, actionType: actionType },
                                });
                            }}
                            style={{
                                background: 'none',
                                border: 'none',
                                padding: 0,
                                color: '#005ea2',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                                font: 'inherit',
                            }}
                        >
                            {label}
                        </button>
                    );
                }
                return label;
            },
        },

        {
            name: 'updatedDate',
            sortName: 'updatedDateRaw',       // <-- SORT ON RAW VALUE
            header: (
                <div className='grid-header-custom-style'>
                    Updated Date
                </div>
            ),
            defaultFlex: 1,
            resizable: true,
            minWidth: 200,

            render: ({ data }: any) => {
                const formatted = data?.updatedDate;
                const raw = data?.updatedDateRaw;

                if (!formatted && !raw) return "";

                return (
                    <div title={raw}>
                        {formatted}
                    </div>
                );
            }
        }

    ];

    const filterValue = savedFilters.UserManagemnetPage ? savedFilters.UserManagemnetPage : [
        { name: 'organization', operator: 'contains', type: 'string', value: '' },
        { name: 'userLastName', operator: 'contains', type: 'string', value: '' },
        { name: 'userFirstName', operator: 'contains', type: 'string', value: '' },
        { name: 'userId', operator: 'contains', type: 'string', value: '' },
        { name: 'startDate', operator: 'contains', type: 'string', value: '' },
        { name: 'endDate', operator: 'contains', type: 'string', value: '' },
        { name: 'funlUserFlag', operator: 'contains', type: 'string', value: '' },
        { name: 'accountStatusLkpcd', operator: 'contains', type: 'string', value: '' },
        { name: 'chngRqst', operator: 'contains', type: 'string', value: '' },
        { name: 'updatedDate', operator: 'contains', type: 'string', value: '' },
    ]

    const [filterDataList, setFilterDataList] = useState<UserList[]>([]);

    // Debounce hook to delay filter execution
    const useDebouncedValue = (value: any, delay = 300) => {
        const [debouncedValue, setDebouncedValue] = useState(value);
        useEffect(() => {
            const handler = setTimeout(() => setDebouncedValue(value), delay);
            return () => clearTimeout(handler);
        }, [value, delay]);
        return debouncedValue;
    };

    // Debounced filter value to optimize performance
    const debouncedFilterValue = useDebouncedValue(filterValue, 300);

    const handleFilterChangeGrid = useCallback((ev: any) => {
        savedFilters.UserManagemnetPage = ev;
        setFilterDataList([]); // Reset filter data on filter change
    }, []);

    // Normalize values for consistent filtering
    const normalizeValue = (value: any): string | Set<string> => {
        if (value === null || value === undefined) return "";
        if (typeof value === "string") return value.trim().toLowerCase()
        if (typeof value === "number" || typeof value === "boolean") return value.toString();
        if (value instanceof Date) return value.toISOString().toLowerCase();
        if (Array.isArray(value)) return new Set(value.map((v) => normalizeValue(v) as string));
        return "";
    };

    const safeString = (val: any) => {
        if (val === null || val === undefined) return "";
        return String(val).trim().toLowerCase();
    };


    const getFilterableValues = (item: any, fieldName: string) => {
        const rawValue = item[fieldName] ?? item[fieldName.toLowerCase()];
        const values: string[] = [];

        if (rawValue !== null && rawValue !== undefined && rawValue !== '') {
            values.push(String(rawValue));
        }

        if (fieldName === 'chngRqst') {
            const displayValue = matchingChangeRequestTypeLkpcd(rawValue);
            if (displayValue && displayValue !== rawValue) {
                values.push(String(displayValue));
            }
        }

        if (fieldName === 'accountStatusLkpcd') {
            const displayValue = matchingAccountStatusLkpcd(rawValue);
            if (displayValue && displayValue !== rawValue) {
                values.push(String(displayValue));
            }
        }

        return values.map((v) => safeString(v));
    };

    // Memoize normalized filter values
    const normalizedFilterValue = useMemo(() => {
        return debouncedFilterValue?.map(({ name, value }: any) => ({
            name,
            value: normalizeValue(value),
        })) ?? [];
    }, [debouncedFilterValue]);

    const applyFilters = useCallback(() => {
        const allFiltersEmpty = normalizedFilterValue.every((f: any) => !f.value);
        if (allFiltersEmpty) {
            setFilterDataList(filteredReportResponseList);
            return;
        }

        const filteredData = filteredReportResponseList.filter((item: any) => {
            return normalizedFilterValue.every(({ name, value }: any) => {
                const resolvedValues =
                    name === 'chngRqst'
                        ? [item.chngRqst, item.chngRqstCode]
                        : name === 'updatedDateRaw'
                            ? [item.updatedDateRaw, item.updatedDate]
                            : [item[name] ?? item[name.toLowerCase()]];

                return resolvedValues.some((resolvedValue: any) => {
                    const rawValue = normalizeValue(resolvedValue);

                    if (rawValue instanceof Set) {
                        return Array.from(rawValue).some((v: any) =>
                            safeString(v).includes(safeString(value))
                        );
                    }

                    const itemValue = safeString(rawValue);
                    return itemValue.includes(safeString(value));
                });
            });
        });

        setFilterDataList(filteredData);
    }, [filteredReportResponseList, normalizedFilterValue]);

    // Apply filters when data or filters change
    useEffect(() => {
        applyFilters();
    }, [applyFilters]);

    const handleRowClick = (data: any) => {
        if (!checkAccess("user_inventory_page", "NOAC")) {
            history.push({
                pathname: "/user-management-details",
                state: { recordData: data },
            });
        }
    };

    // Mapping function to format lookup values
    const mapLookupValues = (item: any) => {
        const mcTableFunlUserFlag = (item?.mcTableFunlUserFlag || "").toString().trim();
        const funlUserFlag = (item?.funlUserFlag || "").toString().trim();

        const rawStatus = item?.accountStatusLkpcd?.toString().trim();
        const rawUpdatedDate =
            (item?.updatedDate || "").toString().trim() ||
            (item?.mucrUpdatedDate || "").toString().trim();


        const formattedUpdated = rawUpdatedDate
            ? formatDateForDisplay(rawUpdatedDate, "MM/DD/YYYY hh:mm:ss.SSS A")
            : "";


        const rawChngRqst = item?.chngRqst?.toString().trim();
        const mappedChngRqst = rawChngRqst
            ? matchingChangeRequestTypeLkpcd(rawChngRqst)
            : "";

        return {
            ...item,
            startDate: item?.startDate
                ? formatDateForDisplay(item.startDate, "MM/DD/YYYY")
                : "",
            endDate: item?.endDate
                ? formatDateForDisplay(item.endDate, "MM/DD/YYYY")
                : "",

            accountStatusLkpcd: rawStatus
                ? matchingAccountStatusLkpcd(rawStatus)
                : "",

            updatedDateRaw: rawUpdatedDate || "",
            updatedDate: formattedUpdated || rawUpdatedDate || "",

            funlUserFlag: mcTableFunlUserFlag === "Y" ? "Yes" : mcTableFunlUserFlag === "N" ? "No" : funlUserFlag === "Y" ? "Yes" : funlUserFlag === "N" ? "No" : "",

            chngRqst: mappedChngRqst,
            chngRqstCode: rawChngRqst || "",
        };
    };

    // Apply mapping when user list changes
    useEffect(() => {
        setFilteredReportResponseList(mcUsersList.map(mapLookupValues));
    }, [mcUsersList]);

    const mappedUsersList = useMemo(() => {
        return mcUsersList.map(mapLookupValues);
    }, [mcUsersList, accountStatusLKPCDList, changeRequestTypeList, userChangeRequestStatusList]);

    useEffect(() => {
        setFilteredReportResponseList(mappedUsersList);
    }, [mappedUsersList]);

    const DEFAULT_LIMIT = 50;
    const getInitialLimit = () => {
        // Try savedFilters first, then sessionStorage, else default
        const stored = sessionStorage.getItem('ContractReportPageLimit');
        return stored ? parseInt(stored, 10) : DEFAULT_LIMIT;
    };
    const [pageLimit, setPageLimit] = useState(getInitialLimit());

    const handleLimitChange = (limit: number) => {
        // If you want to persist across reloads, also save to sessionStorage/localStorage
        sessionStorage.setItem('ContractReportPageLimit', limit.toString());
        setPageLimit(limit);
    };

    const isActionButtonsDisabled =
        !hasSingleSelection ||
        !mcUsersList ||
        mcUsersList.length === 0 ||
        !checkAccess('user_inventory_page', 'FULL');

    type ActionType = 'CLOSE' | 'REINSTATE' | 'LOCK_UNLOCK' | 'MODIFY' | null;

    const [isActionModalOpen, setIsActionModalOpen] = useState(false);
    const [actionType, setActionType] = useState<ActionType>(null);
    const [actionNotes, setActionNotes] = useState('');
    const [editForm, setEditForm] = useState({
        userFirstName: '',
        userLastName: '',
        userEmail: '',
        orgUnitCd: '',
        accountStatusLkpcd: '',
        startDate: '',
        endDate: '',
        updatedBy: '',
    });

    const openActionModal = (type: Exclude<ActionType, null>) => {
        setActionType(type);
        setActionNotes('');

        if (selectedUserRecord) {
            setEditForm({
                userFirstName: selectedUserRecord.userFirstName || '',
                userLastName: selectedUserRecord.userLastName || '',
                userEmail: selectedUserRecord.userEmail || '',
                orgUnitCd: selectedUserRecord.orgUnitCd || '',
                accountStatusLkpcd: selectedUserRecord.accountStatusLkpcd || '',
                startDate: selectedUserRecord.startDate || '',
                endDate: selectedUserRecord.endDate || '',
                updatedBy: loggedInUserDetails?.userEmail || '',
            });
        }

        setIsActionModalOpen(true);
    };

    const closeActionModal = () => {
        setIsActionModalOpen(false);
        setActionType(null);
        setActionNotes('');
    };

    const getActionHeader = () => {
        const rawSelectedUser = mcUsersList.find(
            (user: any) => user.userDetailsSid === selectedUserRecord?.userDetailsSid
        );

        if (actionType === 'CLOSE') return 'Close User';
        if (actionType === 'REINSTATE') return 'Reinstate User';
        if (actionType === 'LOCK_UNLOCK') {
            return rawSelectedUser?.accountStatusLkpcd === 'L' ? 'Unlock User' : 'Lock User';
        }
        if (actionType === 'MODIFY') return 'Modify/Edit User';
        return 'Action';
    };

    const getResolvedAction = () => {
        if (!selectedUserRecord || !actionType) return null;

        const rawSelectedUser = mcUsersList.find(
            (user: any) => user.userDetailsSid === selectedUserRecord.userDetailsSid
        );

        if (actionType === 'LOCK_UNLOCK') {
            return rawSelectedUser?.accountStatusLkpcd === 'L' ? 'UNLOCK' : 'LOCK';
        }

        return actionType; // CLOSE, MODIFY, REINSTATE
    };

    const isModifyMode = actionType === 'MODIFY';

    const getSuccessMessage = (resolvedAction: string) => {
        switch (resolvedAction) {
            case 'LOCK':
                return 'User locked successfully';
            case 'UNLOCK':
                return 'User unlocked successfully';
            case 'CLOSE':
                return 'User closed successfully';
            case 'MODIFY':
                return 'User updated successfully';
            case 'REINSTATE':
                return 'User reinstated successfully';
            default:
                return 'User action completed successfully';
        }
    };

    const handleActionSave = async () => {
        if (!selectedUserRecord || !actionType) return;

        const resolvedAction = getResolvedAction();
        if (!resolvedAction) return;

        const requestBody =
            resolvedAction === 'MODIFY'
                ? {
                    ...editForm,
                    notes: actionNotes,
                }
                : {
                    notes: actionNotes,
                    updatedBy: loggedInUserDetails?.userEmail || '',
                };

        try {
            const response = await ReportInventoryService.updateUserAction(
                selectedUserRecord.userDetailsSid,
                resolvedAction,
                requestBody
            );

            if (!response) {
                throw new Error('No response returned from API');
            }

            if (response.status === 200) {
                toast.success(response?.data?.message || getSuccessMessage(resolvedAction));
                closeActionModal();
                return;
            }

            toast.error(response?.data?.error || response?.data?.message || 'An error occurred while performing the action');
        } catch (error: any) {
            toast.error(
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                error?.message ||
                'An error occurred while performing the action'
            );
        }
    };

    const handleAddUserSubmit = async () => {
        const accountType = addUserForm.accountTypeLkpcd;
        const orgCode = addUserForm.organizationUnitCode;
        const email = (addUserForm.userEmail || '').trim().toLowerCase();
        const oprtnlUserFlag = addUserForm.oprtnlUserFlag === 'Y' ? 'Y' : 'N';

        if (!accountType) {
            toast.error('Account Type is required');
            return;
        }
        if (!orgCode) {
            toast.error('Organization is required');
            return;
        }
        if (!email) {
            toast.error('User/Email ID is required');
            return;
        }
        if (!isValidEmail(email)) {
            toast.error('Please enter a valid email address');
            return;
        }

        if (allowedDomains.length > 0) {
            const emailDomain = email.split('@')[1];

            if (!allowedDomains.includes(emailDomain)) {
                toast.error(`Email domain '${emailDomain}' is not allowed for the selected organization`);
                return;
            }
        }

        if (accountType === 'S' && !email.endsWith('@nebraska.gov')) {
            toast.error('State user email domain must be nebraska.gov');
            return;
        }

        if (addUserForm.oprtnlUserFlag !== 'Y') {
            const proceed = await confirmYesNo('Are you sure you want to add this user as non-operational user?');
            if (!proceed) return;
        }

        try {
            setIsAddSubmitting(true);

            const payload = {
                accountTypeLkpcd: accountType,
                organizationUnitCode: orgCode,
                userId: email,
                oprtnlUserFlag: oprtnlUserFlag,
                createdBy: loggedInUserDetails?.userEmail || '',
                updatedBy: loggedInUserDetails?.userEmail || '',
            };

            const createResp = await ReportInventoryService.createUserChangeRequestService(payload);

            if (createResp?.status === 200) {
                if (createResp?.data?.message === 'USER_EXISTS_IN_MC_USER') {
                    toast.error(Error_Messages.USER_EXISTS_IN_MC_USER);
                } else if (createResp?.data?.message === 'USER_EXISTS_IN_MC_USER_CHANGE_REQUEST') {
                    toast.error(Error_Messages.USER_EXISTS_IN_MC_USER_CHANGE_REQUEST);
                } else {
                    const changeRequestId = createResp?.data?.message;
                    toast.success('User add request created successfully');
                    onAddUserModalClose();
                    history.push({
                        pathname: '/user-account-change-request',
                        state: { chngRqstSid: changeRequestId },
                    });

                    // await fetchAllMcUsersData();
                }
            } else if (createResp?.status === 500) {
                toast.error('Internal server error Unable to create add-user change request');
            }
        } catch (error: any) {
            toast.error('Unable to create add-user change request');
            // onAddUserModalClose();
        } finally {
            setIsAddSubmitting(false);
        }
    };

    const checkSelectedUserRecordStatus = async (selectedUserRecord: any, actionType: string) => {
        console.log('Checking user status for:', selectedUserRecord);

        if (actionType === 'L' || actionType === 'U' || actionType === 'M') {
            const proceed = await confirmYesNo(`Are you sure that you want to ${actionType === 'L' ? 'lock this user?' : actionType === 'U' ? 'unlock this user?' : 'modify this user details and/or associations?'}`);
            if (!proceed) return;
        }

        try {

            const payload = {
                mcUserSid: selectedUserRecord?.userSid,
                userEmailId: selectedUserRecord.userId,
                orgID: selectedUserRecord.organization,
                updatedBy: loggedInUserDetails?.userEmail || "",
                actionType: actionType,
                // request: {
                //     master: masterPayload,
                //     reviewAssignments: reviewAssignmentsPayload,
                //     groupMemberships: groupMembershipPayload,
                //     mcoAuthorities: mcoAuthorityPayload
                // }
            };

            const checkUserStatus = await ReportInventoryService.getUserChangeRequestByEmailAndOrgUnit(payload);

            if (checkUserStatus?.status === 200) {
                if (checkUserStatus?.data?.message === 'USER_EXISTS_IN_MC_USER_CHANGE_REQUEST') {
                    toast.error(Error_Messages.CHECK_CHNAGE_REQ_USER_STATUS);
                } else if (checkUserStatus?.data?.message === 'Email_address_is_empty') {
                    toast.error('User details not found');
                } else {
                    history.push({
                        pathname: '/user-account-change-request',
                        state: { chngRqstSid: checkUserStatus?.data?.message, actionType: actionType },
                    });
                }
            } else if (checkUserStatus?.status === 500) {
                toast.error('Internal server error Unable to check user record status');
            } else if (checkUserStatus?.status === 404) {
                history.push({
                    pathname: '/user-account-change-request',
                    state: { chngRqstSid: checkUserStatus?.data?.message, actionType: actionType },
                });
            }
        } catch (error: any) {
            const status = error?.response?.status;

            if (status === 404) {
                history.push({
                    pathname: '/user-account-change-request',
                    state: { chngRqstSid: error?.response?.data?.message, actionType },
                });
                return;
            }

            if (status === 500) {
                toast.error('Internal server error Unable to check user record status');
                return;
            }

            toast.error('Unable to check user record status');
        }
    };

    type DisableRule = (record: any) => boolean;

    const getRawSelectedRecord = () => {
        if (!selectedUserRecord) return null;

        const rowId = getRowId(selectedUserRecord);
        return mcUsersList.find((row: any) => getRowId(row) === rowId) || selectedUserRecord;
    };

    const shouldDisableButton = (rules: DisableRule[] = []) => {
        const record = getRawSelectedRecord();
        if (!record) return false; // before selection: enabled
        return rules.some((rule) => rule(record));
    };

    const buttonDisableRules = {
        VIEW: [
            (r: any) => r?.accountStatusLkpcd == null && r?.chngRqst === 'A',
        ],
        ADD: [
            (r: any) => r?.accountStatusLkpcd == 'A' && r?.chngRqst === null,
            (r: any) => r?.accountStatusLkpcd == 'A' && r?.chngRqst === 'M',
            (r: any) => r?.accountStatusLkpcd == 'A' && r?.chngRqst === 'L',
            (r: any) => r?.accountStatusLkpcd == 'L' && r?.chngRqst === 'A',
            (r: any) => r?.accountStatusLkpcd == 'L' && r?.chngRqst === 'U',
            (r: any) => r?.accountStatusLkpcd == null && r?.chngRqst === 'A',
            (r: any) => r?.accountStatusLkpcd == 'L' && r?.chngRqst === null,
        ],
        MODIFY: [
            (r: any) => r?.accountStatusLkpcd == 'A' && r?.chngRqst === 'M',
            (r: any) => r?.accountStatusLkpcd == 'A' && r?.chngRqst === 'L',
            (r: any) => r?.accountStatusLkpcd == 'L' && r?.chngRqst === 'A',
            (r: any) => r?.accountStatusLkpcd == 'L' && r?.chngRqst === 'U',
            (r: any) => r?.accountStatusLkpcd == null && r?.chngRqst === 'A',
            (r: any) => r?.accountStatusLkpcd == 'L' && r?.chngRqst === null,
        ],
        LOCK_UNLOCK: [
            (r: any) => r?.accountStatusLkpcd == 'A' && r?.chngRqst === 'M',
            (r: any) => r?.accountStatusLkpcd == 'A' && r?.chngRqst === 'L',
            (r: any) => r?.accountStatusLkpcd == 'L' && r?.chngRqst === 'U',
            (r: any) => r?.accountStatusLkpcd == null && r?.chngRqst === 'A',
        ],
        CHANGE_REQ_EDIT: [
            (r: any) => r?.accountStatusLkpcd == 'A' && r?.chngRqst === null,
            // (r: any) => r?.accountStatusLkpcd == 'A' && r?.chngRqst === 'M',
            // (r: any) => r?.accountStatusLkpcd == 'A' && r?.chngRqst === 'L',
            (r: any) => r?.accountStatusLkpcd == 'L' && r?.chngRqst === 'A',
            // (r: any) => r?.accountStatusLkpcd == 'L' && r?.chngRqst === 'U',
            // (r: any) => r?.accountStatusLkpcd == null && r?.chngRqst === 'A',
            (r: any) => r?.accountStatusLkpcd == 'L' && r?.chngRqst === null,
        ],
    };

    return (
        <>
            <Navbar />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ alignSelf: 'flex-start' }}>
                    <BackButton />
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <PageSubTitle text="User Inventory" />
                </div>
            </div>
            <div className="form-layout">
                {!isNonStateUser ? (
                    <div className="filters-row grid-cols-1 gap-4 md:grid-cols-2 lg:flex lg:justify-between lg:flex-wrap lg:items-center">
                        <div className="external-filters-elem w-full lg:w-auto lg:max-w-xs">
                            <Dropdown
                                choices={serachDropdownChoices1}
                                emptyChoiceLabel="Select Filter Criteria 1"
                                name="filterCriteria1"
                                label=""
                                data-testid="payment_type_testid"
                                value={selectedOption1 ? selectedOption1 : ''}
                                onChange={handleFilterChange1}
                                disabled={filterSearchOption}
                            />
                        </div>
                        <div className="external-filters-elem w-full lg:w-auto lg:max-w-xs">
                            <InputText
                                context="registration"
                                name="search"
                                placeholder="Filter 1"
                                value={filter1Text || ''}
                                onChange={handleFilterText1}
                                small={true}
                                disabled={filterSearchOption}
                            />
                        </div>
                        <div className="external-filters-elem w-full lg:w-auto lg:max-w-xs">
                            <Dropdown
                                choices={serachDropdownChoices2}
                                emptyChoiceLabel="Select Filter Criteria 2"
                                name="filterCriteria2"
                                label=""
                                data-testid="payment_type_testid"
                                value={selectedOption2 ? selectedOption2 : ''}
                                onChange={handleFilterChange2}
                                disabled={(!selectedOption1 && !filter1Text) || filter1Text === '' || filter1Text === null || filterSearchOption}
                            />
                        </div>
                        <div className="external-filters-elem w-full lg:w-auto lg:max-w-xs">
                            <InputText
                                context="registration"
                                name="search"
                                placeholder="Filter 2"
                                value={filter2Text || ''}
                                onChange={handleFilterText2}
                                small={true}
                                disabled={(!selectedOption1 && !filter1Text) || filter1Text === '' || filter1Text === null || filterSearchOption}

                            />
                        </div>
                        <div className="external-filters-action flex justify-end w-full lg:w-auto" style={{ marginBottom: '-20px' }}>
                            <Button
                                disabled={
                                    !(
                                        (selectedOption1 && filter1Text) ||
                                        (selectedOption2 && filter2Text)
                                    )
                                }
                                className="OkButton"
                                onClick={() => handleClear()}
                            >
                                Clear
                            </Button>
                            <Button
                                disabled={
                                    !(
                                        (selectedOption1 && filter1Text) ||
                                        (selectedOption2 && filter2Text)
                                    )
                                }
                                className="OkButton"
                                onClick={handleSearch}
                            >
                                Search
                            </Button>
                            <Button
                                className="OkButton"
                                onClick={toggleModal}
                                disabled={(!mcUsersList || mcUsersList.length === 0) || !checkAccess('user_inventory_page', 'FULL')}
                            >
                                Export to Excel
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div className="filters-row grid-cols-1 gap-4 md:grid-cols-2 lg:flex lg:justify-between lg:flex-wrap lg:items-center">
                        <div className="external-filters-action flex justify-end w-full lg:w-auto" style={{ marginBottom: '-20px' }}>
                            <Button
                                className="OkButton"
                                onClick={toggleModal}
                                disabled={(!mcUsersList || mcUsersList.length === 0) || checkAccess('user_inventory_page', 'FULL')}
                            >
                                Export to Excel
                            </Button>
                        </div>
                    </div>
                )}

                <div className="filters-row grid-cols-1 gap-4 md:grid-cols-2 lg:flex lg:justify-between lg:flex-wrap lg:items-center">
                    <div className="external-filters-action flex justify-end w-full lg:w-auto" style={{ marginBottom: '20px', margin: '0 auto' }}>
                        <Button
                            className="OkButton"
                            onClick={handleViewClick}
                            disabled={!selectedUserRecord || shouldDisableButton(buttonDisableRules.VIEW)}
                        >
                            View
                        </Button>

                        <Button
                            className="OkButton"
                            onClick={handleAddAccountClick}
                            disabled={shouldDisableButton(buttonDisableRules.ADD) ||
                                (sessionStorage.getItem('selectedProfile') !== `DHHS_AR_NEMCIS_STT${envPrefix}-SUP-ADMIN` &&
                                    sessionStorage.getItem('selectedProfile') !== `DHHS_AR_NEMCIS_STT${envPrefix}-APP-ADMIN`)
                            }
                        >
                            Add
                        </Button>

                        <Button
                            className="OkButton"
                            onClick={() => checkSelectedUserRecordStatus(selectedUserRecord, 'M')}
                            disabled={!selectedUserRecord || shouldDisableButton(buttonDisableRules.MODIFY) ||
                                (sessionStorage.getItem('selectedProfile') !== `DHHS_AR_NEMCIS_STT${envPrefix}-SUP-ADMIN` &&
                                    sessionStorage.getItem('selectedProfile') !== `DHHS_AR_NEMCIS_STT${envPrefix}-APP-ADMIN`)
                            }
                        >
                            Modify
                        </Button>

                        <Button
                            className="OkButton"
                            onClick={() => checkSelectedUserRecordStatus(selectedUserRecord, selectedUserRecord?.accountStatusLkpcd === 'Active' ? 'L' : 'U')}
                            disabled={!selectedUserRecord || shouldDisableButton(buttonDisableRules.LOCK_UNLOCK) ||
                                (sessionStorage.getItem('selectedProfile') !== `DHHS_AR_NEMCIS_STT${envPrefix}-SUP-ADMIN` &&
                                    sessionStorage.getItem('selectedProfile') !== `DHHS_AR_NEMCIS_STT${envPrefix}-APP-ADMIN`)
                            }
                        >
                            Lock/Unlock
                        </Button>
                        <Button className="OkButton" onClick={handleCancelButton}>
                            Cancel
                        </Button>
                    </div>
                </div>

                <Modal
                    isOpen={isExportModalOpen}
                    onRequestClose={toggleModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="Export data"
                    style={{
                        content: {
                            width: '500px',
                            height: '500px',
                            margin: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                        },
                    }}
                >
                    <h2 style={{ marginBottom: '20px' }}><b>Select Fields for Export</b></h2>
                    <div>
                        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                id="selectAll"
                                checked={selectedHeaders.length === headers.length}
                                onChange={handleSelectAllChange}
                                style={{ width: '15px', height: '15px', marginRight: '10px' }}
                            />
                            <label htmlFor="selectAll" style={{ verticalAlign: 'middle' }}>Select All</label>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                            {headers.map((header) => (
                                <div key={header} style={{ display: 'flex', alignItems: 'center' }}>
                                    <input
                                        type="checkbox"
                                        id={header}
                                        checked={selectedHeaders.includes(header)}
                                        onChange={() => handleHeaderChange(header)}
                                        style={{ width: '15px', height: '15px', marginRight: '10px' }}
                                    />
                                    <label htmlFor={header} style={{ verticalAlign: 'middle' }}>{header}</label>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="usa-form-group" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', height: '100%' }}>
                        <button
                            disabled={selectedHeaders.length === 0 ||
                                checkAccess('user_inventory_page', 'VWNA') || checkAccess('user_inventory_page', 'NOAC')
                            }
                            className='usa-button'
                            onClick={handleExportToExcel}
                        >
                            Download Excel
                        </button>
                        <button
                            className='usa-button'
                            onClick={toggleModal}
                        >
                            Close
                        </button>
                    </div>
                </Modal>

                <Modal
                    isOpen={isActionModalOpen}
                    onRequestClose={closeActionModal}
                    shouldCloseOnOverlayClick={false}
                    contentLabel="User action modal"
                    style={{
                        content: {
                            width: '700px',
                            height: '600px',
                            margin: 'auto',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            border: '2px solid #1e63ad',
                        },
                    }}
                >
                    <h2 style={{ marginBottom: '12px', textAlign: 'center', fontWeight: 800, fontSize: 'larger' }}>
                        {getActionHeader()}
                    </h2>

                    <div
                        style={{
                            borderBottom: '1.5px solid #1e63ad',
                            marginBottom: '14px'
                        }}
                    />
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '12px' }}>
                        <div>
                            <label><b>First Name</b></label>
                            <input
                                type="text"
                                value={editForm.userFirstName}
                                readOnly={!isModifyMode}
                                onChange={(e) => setEditForm((p) => ({ ...p, userFirstName: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    border: '1px solid #b0b0b0',
                                    borderRadius: '4px',
                                    background: isModifyMode ? '#fff' : '#f7f7f7',
                                    cursor: isModifyMode ? "text" : "not-allowed"
                                }}
                            />
                        </div>
                        <div>
                            <label><b>Last Name</b></label>
                            <input
                                type="text"
                                value={editForm.userLastName}
                                readOnly={!isModifyMode}
                                onChange={(e) => setEditForm((p) => ({ ...p, userLastName: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    border: '1px solid #b0b0b0',
                                    borderRadius: '4px',
                                    background: isModifyMode ? '#fff' : '#f7f7f7',
                                    cursor: isModifyMode ? "text" : "not-allowed"
                                }}
                            />
                        </div>
                        <div>
                            <label><b>Email</b></label>
                            <input
                                type="text"
                                value={editForm.userEmail}
                                readOnly={!isModifyMode}
                                onChange={(e) => setEditForm((p) => ({ ...p, userEmail: e.target.value }))}
                                style={{
                                    width: '100%',
                                    padding: '8px',
                                    border: '1px solid #b0b0b0',
                                    borderRadius: '4px',
                                    background: isModifyMode ? '#fff' : '#f7f7f7',
                                    cursor: isModifyMode ? "text" : "not-allowed"
                                }}
                            />
                        </div>
                        <div>
                            <label><b>Organization</b></label>
                            <input
                                type="text"
                                value={editForm.orgUnitCd}
                                readOnly={!isModifyMode}
                                onChange={(e) => setEditForm((p) => ({ ...p, orgUnitCd: e.target.value }))}
                                style={{ width: '100%', padding: '8px', border: '1px solid #b0b0b0', borderRadius: '4px', background: isModifyMode ? '#fff' : '#f7f7f7', cursor: isModifyMode ? "text" : "not-allowed" }}
                            />
                        </div>
                        <div>
                            <label><b>Start Date</b></label>
                            <input
                                type="text"
                                value={editForm.startDate}
                                readOnly={!isModifyMode}
                                onChange={(e) => setEditForm((p) => ({ ...p, startDate: e.target.value }))}
                                style={{ width: '100%', padding: '8px', border: '1px solid #b0b0b0', borderRadius: '4px', background: isModifyMode ? '#fff' : '#f7f7f7', cursor: isModifyMode ? "text" : "not-allowed" }}
                            />
                        </div>
                        <div>
                            <label><b>End Date</b></label>
                            <input
                                type="text"
                                value={editForm.endDate}
                                readOnly={!isModifyMode}
                                onChange={(e) => setEditForm((p) => ({ ...p, endDate: e.target.value }))}
                                style={{ width: '100%', padding: '8px', border: '1px solid #b0b0b0', borderRadius: '4px', background: isModifyMode ? '#fff' : '#f7f7f7', cursor: isModifyMode ? "text" : "not-allowed" }}
                            />
                        </div>
                        <div>
                            <label><b>Current Status</b></label>
                            <input
                                type="text"
                                value={matchingAccountStatusLkpcd(editForm.accountStatusLkpcd)}
                                readOnly={!isModifyMode}
                                onChange={(e) => setEditForm((p) => ({ ...p, accountStatusLkpcd: e.target.value }))}
                                style={{ width: '100%', padding: '8px', border: '1px solid #b0b0b0', borderRadius: '4px', background: isModifyMode ? '#fff' : '#f7f7f7', cursor: isModifyMode ? "text" : "not-allowed" }}
                            />
                        </div>
                    </div>

                    <div>
                        <label htmlFor="actionNotes"><b>Notes</b></label>
                        <textarea
                            id="actionNotes"
                            value={actionNotes}
                            onChange={(e) => setActionNotes(e.target.value)}
                            rows={6}
                            placeholder="Enter notes..."
                            style={{
                                width: '100%',
                                marginTop: '8px',
                                padding: '8px',
                                border: '1px solid #7a7a7a',
                                borderRadius: '4px',
                                outline: 'none'
                            }}
                        />
                    </div>

                    <div className="usa-form-group" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button className="usa-button" onClick={closeActionModal}>
                            Cancel
                        </button>
                        <button className="usa-button" onClick={handleActionSave}>
                            Save
                        </button>
                    </div>
                </Modal>

                {isLoading ? (
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Loading.....</p>
                    </div>
                ) :
                    <>
                        <ReactDataGrid
                            licenseKey="AppName=CoherenceApp,Company=Coherence,ExpiryDate=2025-04-15T00:00:00.000Z,LicenseDeveloperCount=1,LicenseType=single_app,Ref=CoherenceLicenseRef,Z=983320388-1513273079-1127323721-2081795733-199375339958733905"
                            idProperty="_rowId"
                            style={gridStyle}
                            pagination
                            columns={UserInventoryHeaders}
                            dataSource={filteredReportResponseList}
                            sortable={true}
                            onFilterValueChange={handleFilterChangeGrid}
                            defaultLimit={pageLimit}
                            onLimitChange={handleLimitChange}
                            defaultFilterValue={filterValue}
                            rowHeight={50}
                            // onRowClick={({ data }) => handleRowClick(data)}
                            onRowClick={handleGridRowClick}
                            className="pointer-cursor-row"
                            enableColumnAutosize={true}
                            handle={setGridRef}
                            pageSizes={[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                        />
                    </>
                }
            </div >

            <Modal
                isOpen={isAddUserModalOpen}
                onRequestClose={onAddUserModalClose}
                shouldCloseOnOverlayClick={false}
                contentLabel="Add User Account"
                style={{
                    content: {
                        width: '620px',
                        height: '420px',
                        margin: 'auto',
                        border: '2px solid #1e63ad',
                    },
                }}
            >
                <h2 style={{ textAlign: 'center', marginBottom: '16px' }}>
                    <b>Add User Account</b>
                </h2>

                <div style={{ display: 'grid', gap: '14px' }}>
                    <div>
                        <label><b>Account Type</b><span className="usa-mandatory-label">*</span></label>
                        <select
                            value={addUserForm.accountTypeLkpcd}
                            onChange={(e) => onAddAccountTypeChange(e.target.value)}
                            style={{ width: '100%', padding: '8px', border: '1px solid #b0b0b0', borderRadius: '4px' }}
                        >
                            <option value="">Select Account Type</option>
                            {stateAndTradingAccountTypes.map((item: any) => (
                                <option key={item.lkpdmn_lkpcd} value={item.lkpdmn_lkpcd}>
                                    {item.lkdmn_lkpcd_desc}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label><b>Organization</b><span className="usa-mandatory-label">*</span></label>
                        <select
                            value={addUserForm.organizationUnitCode}
                            // onChange={(e) =>
                            //     setAddUserForm((prev) => ({ ...prev, organizationUnitCode: e.target.value }))
                            // }
                            onChange={handleOrgChange}
                            disabled={!addUserForm.accountTypeLkpcd}
                            style={{ width: '100%', padding: '8px', border: '1px solid #b0b0b0', borderRadius: '4px' }}
                        >
                            <option value="">Select Organization</option>
                            {organizationChoicesForSelectedAccountType.map((org: any) => (
                                <option key={org.organizationUnitCode} value={org.organizationUnitCode}>
                                    {org.organizationUnitCode} - {org.organizationUnitName}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label><b>User/Email ID</b><span className="usa-mandatory-label">*</span></label>
                        <input
                            type="text"
                            value={addUserForm.userEmail}
                            onChange={(e) =>
                                setAddUserForm((prev) => ({ ...prev, userEmail: e.target.value }))
                            }
                            // onChange={handleEmailChange}
                            style={{ width: '100%', padding: '8px', border: '1px solid #b0b0b0', borderRadius: '4px' }}
                        />
                    </div>

                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <input
                            type="checkbox"
                            checked={addUserForm.oprtnlUserFlag === 'Y'}
                            disabled={addUserForm.accountTypeLkpcd === 'S'}
                            onChange={(e) =>
                                setAddUserForm((prev) => ({ ...prev, oprtnlUserFlag: e.target.checked ? 'Y' : 'N' }))
                            }
                        />
                        <label><b>Operational User</b></label>
                    </div>
                </div>

                <div className="usa-form-group" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '24px' }}>
                    <button className="usa-button" onClick={onAddUserModalClose} disabled={isAddSubmitting}>
                        Cancel
                    </button>
                    <button className="usa-button" onClick={handleAddUserSubmit} disabled={isAddSubmitting ||
                        !addUserForm.accountTypeLkpcd || !addUserForm.organizationUnitCode || !addUserForm.userEmail
                    }>
                        Submit
                    </button>
                </div>
            </Modal>
            <Footer />
        </>

    );
}
export default UserManagement;